import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  customStyle,
  nativeStyleEnd,
  styleEnd,
} from "../../algorithms/styleDirection";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  addPostComment,
  getPost,
} from "../../API/store/actions/discussion/discussion";
import { CommentsIcon } from "../reusableComponents/svgIcons";
import Button from "../sharedComponents/buttons/button";
import TextArea from "../sharedComponents/textarea/textArea";
import Lang from "../../userPreferences/staticWords";
import { paths } from "../../paths/paths";
import {
  formatDateLL,
  objToFormData,
  ScrollToTop,
} from "./../../algorithms/index";
import DiscussionCommentsCard from "./discussionCommentsCard";
import FileInput from "../sharedComponents/inputs/fileInput";
import { useFormik } from "formik";
import { initialValues } from "./../projects/formikValidation";
import { formikSetup, validationSchema } from "../tasks/formikValidation";
import { useSelector } from "react-redux";
import { positionStyle } from "./../../algorithms/styleDirection";
import { HubConnectionBuilder } from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import * as Constant from "../../constant.module.json";
const DiscussionDetails = ({ userToken }) => {
  const userLogged = useSelector((state) => state.login.userData);
  const [connection, setConnection] = useState(null);

  const [data, setData] = useState({});
  const [showComments, setShowComments] = useState(true);
  const [showReplys, setShowReplays] = useState({});
  const [comments, setComments] = useState([]);
  const [commentId, setCommentId] = useState(null);

  const { id } = useParams();
  const commentsRef = useRef(null);
  const item = data?.data;
  useEffect(() => {
    resolver(getPost, setData, id, userToken);
    ScrollToTop();
  }, []);
  useEffect(() => {
    if (item?.comments?.length) setComments(item?.comments);
  }, [item]);

  useEffect(() => {
    const connect = new HubConnectionBuilder()
      .withUrl(`${Constant.hubURLProjects}/commentHub`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();
    setConnection(connect);
    return () => {
      connect.stop();
    };
  }, []);

  useEffect(() => {
    if (connection) {
      if (connection.state === "Disconnected") {
        connection.start();
        connection.on("connected", () => {
          connection.invoke("JoinGroup", "forumComment" + id).then(() => {});
          // setConnectionId(id);
        });
      }
      connection.on("ReceiveComment", (message) => {
        setComments([...comments, { ...message }]);
      });
    }
  }, [connection, comments]);

  const submit = async (values) => {
    values.ForumId = parseInt(item.id);
    values.MemberId = parseInt(userLogged?.memberId);

    let data = objToFormData(values);
    values.Description = "";
    let res = await addPostComment(data, userToken);
    if (res.status <= 206) {
      if (connection)
        await connection.invoke("SendMessage", res?.data, "forumComment" + id);
      // setCommentId(res?.data);
    }
  };
  const formik = useFormik(
    formikSetup(initialValues, undefined, validationSchema, "comment", submit)
  );
  const { values, handleChange, setFieldValue, touched, errors, handleSubmit } =
    formik;
  if (item)
    return (
      <>
        <div className=" d-flex flex-column  align-items-center container col-9 my-3">
          <div
            className="w-100"
            style={{
              border: "solid 1px #DFDFE2",
              borderRadius: 10,
              cursor: "pointer",
              zIndex: 0,
            }}
          >
            <div className="px-4 py-2" id={item.id}>
              <div style={{ color: "#000000", fontWeight: "bold" }}>
                {item.title}
              </div>
              <div className="text-muted my-2" style={{ fontSize: 13 }}>
                {formatDateLL(item.createDate)}
              </div>
              <div style={{ color: "#444444" }}>{item.description}</div>
              <div className=" d-flex my-3" style={{ color: "#000000" }}>
                <div className="mx-2">
                  <img src={`${paths.Members}${item.id}/${item.memberPhoto}`} />
                </div>
                <div className="mx-2">{item.memberName}</div>
              </div>
            </div>
            <div
              style={{
                backgroundColor: "#F2F2F2",
                borderTopRightRadius: 10,
                borderTopLeftRadius: 10,
                // borderBottom: "2px solid rgba(53, 132, 234, 0.5)",
              }}
              className="d-flex flex-wrap justify-content-around"
            >
              <div
                className="d-flex align-items-center justify-content-center py-3 mx-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  commentsRef.current.focus();
                }}
              >
                <div className="mx-2">
                  <CommentsIcon />
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <p
                    className="my-0"
                    style={{ color: "#1a73e8", fontSize: 14 }}
                  >
                    {Lang.addComment}
                  </p>
                </div>
              </div>

              <div
                id={item.id}
                className="d-flex align-items-center justify-content-center py-4 mx-3 position-relative"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  setShowComments(!showComments);
                }}
              >
                <div
                  className="position-absolute"
                  style={{
                    top: 12,
                  }}
                >
                  <CommentsIcon />
                </div>

                <div
                  className={`mx-2 position-absolute ${customStyle(
                    "commentsNumber"
                  )}`}
                >
                  <div
                    className={`d-flex justify-content-center align-items-center ${styleEnd(
                      "m",
                      2
                    )}`}
                    style={{
                      color: "white",
                      backgroundColor: "#1A73E8",
                      borderRadius: "50%",
                      minWidth: "fit-content",
                      minHeight: "fit-content",
                      width: 20,
                      height: 20,
                      fontSize: 11,
                    }}
                  >
                    {item.comments.length}
                  </div>
                </div>
              </div>
              <form onSubmit={handleSubmit} style={{ display: "contents" }}>
                <div className="col-12 position-relative bg-white">
                  <TextArea
                    ref={commentsRef}
                    placeholder={"اضف تعليق ..."}
                    // containerStyle={"col-11"}
                    rows={2}
                    style={{ ...nativeStyleEnd("padding", 80) }}
                    name={"Description"}
                    onChange={handleChange}
                    value={values.Description}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      ...positionStyle(0),
                    }}
                  >
                    <Button
                      type={"submit"}
                      content={"اضف"}
                      height={54}
                      styleClass={"solid"}
                      customStyle={{ width: 60 }}
                    />
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: 18,
                      ...positionStyle(47),
                    }}
                    className="px-2"
                  >
                    <FileInput
                      name={"Attachment"}
                      onChange={(e) => {
                        setFieldValue("Attachment", e.target.files[0]);
                      }}
                      iconName={"paperclip"}
                      iconPrefix={"fas"}
                      size={15}
                      iconColor={values.Attachment ? "#1a73e8" : "#C7C7C9"}
                      backgroundSize={15}
                      backgroundColor={"white"}
                      fileName={" "}
                      containerStyle={""}
                      accept={".gif, .jpg, .png, .doc, .pdf, .xlsx"}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          {showComments ? (
            <div
              className={` p-2 w-100`}
              style={{
                //   borderRadius: 8,
                borderBottomRightRadius: 8,
                borderBottomLeftRadius: 8,
              }}
            >
              {comments.length ? (
                comments.map((comment, index) => {
                  return (
                    <DiscussionCommentsCard
                      key={index}
                      userToken={userToken}
                      comment={comment}
                      index={index}
                      length={comments.length - 1}
                      setShowReplays={setShowReplays}
                      showReplys={showReplys}
                    />
                  );
                })
              ) : (
                <div className=" text-center"> لا يوجد تعليقات </div>
              )}
            </div>
          ) : null}
        </div>
      </>
    );
  return <></>;
};

export default DiscussionDetails;
